import { initialState } from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT:
      return { ...initialState };
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload?.[actionTypes.ACTION_PROCESSING],
      };
    case actionTypes.GET_FEEDBACK_LINK:
      return { ...state, ...action.payload };

    default:
      return { ...state };
  }
};
